export const projectContainerCompanyKeys = {
  all: (projectContainerId: number | undefined) => ['projectContainerCompany', projectContainerId] as const,
  overview: (projectContainerId: number | undefined) =>
    ['projectContainerCompany', projectContainerId, 'overview'] as const,
  policies: (projectContainerId: number | undefined) =>
    ['projectContainerCompany', projectContainerId, 'policies'] as const,
  contacts: (projectContainerId: number | undefined) =>
    ['projectContainerCompany', projectContainerId, 'contacts'] as const,
  contracts: (projectContainerId: number | undefined) =>
    ['projectContainerCompany', projectContainerId, 'contracts'] as const
};
